import { CHART_ELEMENT_ID } from 'finviz-charts/app/constants/common'
import { Suspense } from 'react'
import ReactDOM from 'react-dom'
import ReactDOMClient from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { NotificationWrapper } from '../../main/components/notification'
import { SpecificChartFunctionality } from '../../main/constants'
import { ResizableChartLayoutWithGlobalState } from '../shared/components/ResizableChartLayoutWithGlobalState'
import { ready } from '../shared/ready'
import { parseInitData } from '../shared/utils'
import FuturesActionCreators from './actions/futuresActionCreators'
import { FuturesCharts } from './futures'
import { FuturesDatum, FuturesTile } from './types'

interface InitDataType {
  groups: FuturesDatum[]
  tiles: Record<string, FuturesTile>
}

function getFuturesInitData() {
  const initData = parseInitData<InitDataType>('futures-init-data')!

  initData.groups.forEach(function (group: any) {
    for (var i = 0; i < group.contracts.length; i++) {
      group.contracts[i] = initData.tiles[group.contracts[i].ticker]
    }
  })

  return initData.groups
}

window['FinvizInitFuturesCharts'] = function () {
  const futuresEl = document.getElementById('futures')
  const dataEl = document.getElementById('futures-init-data')
  if (!futuresEl) return

  if (dataEl) {
    try {
      const initData = getFuturesInitData()
      FuturesActionCreators.init(initData)
    } catch {
      return
    }
  }

  const root = ReactDOMClient.createRoot(futuresEl)
  root.render(
    <BrowserRouter>
      <FuturesCharts />
    </BrowserRouter>
  )
}

ready(function () {
  const futuresEl = document.getElementById('futures')
  const chartEl = document.getElementById(CHART_ELEMENT_ID)
  const dataEl = document.getElementById('futures-init-data')

  if (!futuresEl || !chartEl || !dataEl || !window.globalChartConfig) return

  try {
    const initData = getFuturesInitData()
    FuturesActionCreators.init(initData)
  } catch {
    return
  }

  const root = ReactDOMClient.createRoot(chartEl)
  root.render(
    <BrowserRouter>
      <NotificationWrapper>
        {ReactDOM.createPortal(<FuturesCharts />, futuresEl)}
        <Suspense fallback={null}>
          <ResizableChartLayoutWithGlobalState
            specificChartFunctionality={SpecificChartFunctionality.futuresPage}
            config={window.globalChartConfig}
          />
        </Suspense>
      </NotificationWrapper>
    </BrowserRouter>
  )
})
